import eventQueries from '@apis/queries/eventQueries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';

function useEvent(eventId: string) {
    const { data } = useQuery(eventQueries.detail(eventId));
    const { pop } = useFlow();
    const toast = useToast();
    return data;
}

export default useEvent;
